/**
 * 底部
 */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'

import logo from '@/assets/image/footer/logo.png'
import { useState } from 'react'
import { submitSubscription } from '@/api/home'
import { message } from 'antd'
import { useMediaQuery } from 'react-responsive';

const Footer = () => {
 const isMobile = useMediaQuery({ maxWidth: 768 });
 const [email, setEmail] = useState('')

 const onSubmit = async () => {
  if (email === '') return message.error('Enter your email address.');
  const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  if (!emailReg.test(email)) return message.error("That doesn't look like a valid email.");

  try {
   submitSubscription({email}).then((res) => {
    message.success('Subscribed.');
   }).catch((e) => {
    message.success('Subscribed.');
   })
   setEmail('')
  } catch (e) {
  }
 }

 return (
  <footer className={`${styles.footer}`}>
   {
    isMobile? (
      <div className={`${styles.box} relative w-1340 flex flex-just flex-wrap`}>
       <div className={`${styles.main} ${styles.search}`}>
        <img className={`${styles.logo}`} src={logo} alt="VISHWA" />
        <div className={`${styles.main_title}`}>The system behind autonomous capital.</div>
        <div className={'flex'}>
         <Link className={`${styles.link}`} target="_blank"
               to="https://www.youtube.com/@vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M12.5 19.9993L18.9875 15.9993L12.5 11.9993V19.9993ZM26.95 9.55935C27.1125 10.186 27.225 11.026 27.3 12.0927C27.3875 13.1593 27.425 14.0793 27.425 14.8793L27.5 15.9993C27.5 18.9193 27.3 21.066 26.95 22.4393C26.6375 23.6393 25.9125 24.4127 24.7875 24.746C24.2 24.9193 23.125 25.0394 21.475 25.1194C19.85 25.2127 18.3625 25.2527 16.9875 25.2527L15 25.3327C9.7625 25.3327 6.5 25.1193 5.2125 24.746C4.0875 24.4127 3.3625 23.6393 3.05 22.4393C2.8875 21.8127 2.775 20.9727 2.7 19.906C2.6125 18.8393 2.575 17.9193 2.575 17.1193L2.5 15.9993C2.5 13.0793 2.7 10.9327 3.05 9.55935C3.3625 8.35935 4.0875 7.58602 5.2125 7.25268C5.8 7.07935 6.875 6.95935 8.525 6.87935C10.15 6.78602 11.6375 6.74602 13.0125 6.74602L15 6.66602C20.2375 6.66602 23.5 6.87935 24.7875 7.25268C25.9125 7.58602 26.6375 8.35935 26.95 9.55935Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://t.me/vishwa_xyz">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M12.2256 24.8673L12.5756 19.2273L22.1756 10.0006C22.6006 9.58727 22.0881 9.38727 21.5256 9.74727L9.67559 17.7339L4.55059 16.0006C3.45059 15.6673 3.43809 14.8539 4.80059 14.2673L24.7631 6.05394C25.6756 5.61394 26.5506 6.29394 26.2006 7.78727L22.8006 24.8673C22.5631 26.0806 21.8756 26.3739 20.9256 25.8139L15.7506 21.7339L13.2631 24.3073C12.9756 24.6139 12.7381 24.8673 12.2256 24.8673Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://x.com/Vishwa_xyz">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <g clipPath="url(#clip0_5583_240)">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M24.5727 6.28125H21.1512L15.7402 12.6088L11.0033 6.35918H4.19922L12.155 16.8012L4.39357 25.8772H7.89287L13.7908 18.9482L19.1294 25.9551H25.8558L17.3636 14.7507L24.5727 6.28125ZM10.0312 8.18852H7.95887L20.1014 24.1256H22.1106L10.0312 8.18852Z"
                  fill="#D3D1D1" />
           </g>
           <defs>
            <clipPath id="clip0_5583_240">
             <rect width="30" height="32" fill="white" />
            </clipPath>
           </defs>
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://medium.com/vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M25.9726 6.22285L26 6.21674V6H20.4092L15.2179 18.4649L10.0267 6.00013H4.00204V6.21674L4.02902 6.22285C5.04946 6.45819 5.56769 6.80911 5.56769 8.07458V22.8907C5.56769 24.1563 5.04755 24.5072 4.02698 24.7426L4 24.7487V24.9659H8.08761V24.7495L8.0605 24.7432C7.04006 24.508 6.52195 24.157 6.52195 22.8915V8.934L13.1907 24.9659H13.5689L20.4319 8.48699V23.2574C20.3444 24.2569 19.831 24.5656 18.9069 24.7787L18.8796 24.7852V25H26V24.7852L25.9726 24.7787C25.0475 24.5656 24.5218 24.2569 24.4343 23.2574L24.4296 8.07458H24.4343C24.4343 6.80911 24.9525 6.45819 25.9726 6.22285Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://www.linkedin.com/company/vishwanetwork">
          <div style={{ width: '32px', height: '30px' }} className={`flex items-center justify-center`}>
           <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <g clipPath="url(#clip0_5583_246)">
             <path
               d="M18.7431 18.7477H15.4853V13.6427C15.4853 12.4254 15.4605 10.8588 13.7876 10.8588C12.089 10.8588 11.8296 12.1834 11.8296 13.5529V18.7477H8.57175V8.25H11.7013V9.68092H11.7434C12.1807 8.85592 13.244 7.98508 14.8326 7.98508C18.1335 7.98508 18.744 10.1576 18.744 12.9855V18.7477H18.7431ZM4.89225 6.81358C4.64372 6.8137 4.39761 6.76481 4.168 6.6697C3.93839 6.5746 3.72979 6.43514 3.55413 6.25932C3.37848 6.0835 3.23923 5.87476 3.14434 5.64506C3.04946 5.41536 3.00081 5.1692 3.00117 4.92067C3.00135 4.54646 3.11249 4.18072 3.32054 3.86968C3.52858 3.55865 3.82419 3.31629 4.16998 3.17325C4.51576 3.03022 4.8962 2.99294 5.26318 3.06612C5.63015 3.1393 5.96719 3.31966 6.23166 3.58439C6.49613 3.84911 6.67617 4.18632 6.74899 4.55337C6.82182 4.92042 6.78416 5.30082 6.6408 5.64647C6.49743 5.99212 6.25478 6.28749 5.94354 6.49523C5.63231 6.70298 5.26645 6.81376 4.89225 6.81358ZM6.52575 18.7477H3.25875V8.25H6.52575V18.7477ZM20.3729 0H1.62342C0.726 0 0 0.7095 0 1.58492V20.4151C0 21.2914 0.726 22 1.62342 22H20.3702C21.2667 22 22 21.2914 22 20.4151V1.58492C22 0.7095 21.2667 0 20.3702 0H20.3729Z"
               fill="#D3D1D1" />
            </g>
            <defs>
             <clipPath id="clip0_5583_246">
              <rect width="22" height="22" fill="white" />
             </clipPath>
            </defs>
           </svg>
          </div>
         </Link>
         <Link className={`${styles.link}`} target="_blank" to="https://discord.gg/vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M18.3785 7C18.144 7.41199 17.9334 7.8382 17.742 8.27387C15.9232 8.00394 14.0709 8.00394 12.2473 8.27387C12.0607 7.8382 11.8453 7.41199 11.6107 7C9.90202 7.28887 8.23635 7.79558 6.65689 8.51065C3.52664 13.0994 2.67947 17.5699 3.10067 21.9787C4.93385 23.3189 6.98716 24.3418 9.17451 24.9952C9.66747 24.3418 10.1031 23.6456 10.4764 22.9211C9.76798 22.6606 9.08354 22.3339 8.42783 21.955C8.60014 21.8319 8.76764 21.704 8.9304 21.5809C12.7738 23.3709 17.2251 23.3709 21.0732 21.5809C21.236 21.7135 21.4035 21.8414 21.5758 21.955C20.9201 22.3386 20.2356 22.6606 19.5225 22.9258C19.8958 23.6504 20.3313 24.3465 20.8244 25C23.0117 24.3465 25.065 23.3283 26.8982 21.9881C27.396 16.8737 26.0462 12.4412 23.3324 8.51541C21.7577 7.80032 20.092 7.29361 18.3833 7.00947L18.3785 7ZM11.0124 19.2652C9.83023 19.2652 8.84899 18.2044 8.84899 16.8927C8.84899 15.5809 9.79189 14.5154 11.0076 14.5154C12.2234 14.5154 13.1902 15.5856 13.1711 16.8927C13.1519 18.1997 12.2186 19.2652 11.0124 19.2652ZM18.9864 19.2652C17.7994 19.2652 16.8278 18.2044 16.8278 16.8927C16.8278 15.5809 17.7707 14.5154 18.9864 14.5154C20.2021 14.5154 21.1642 15.5856 21.145 16.8927C21.1259 18.1997 20.1926 19.2652 18.9864 19.2652Z"
             fill="#D3D1D1" />
          </svg>
         </Link>
        </div>
       </div>

       <div className={`${styles.menu} flex`}>
        <div className={`${styles.menu_item} flex`}>
         <Link target="_self" className={`flex`} to="/blog">Blogs</Link>
         <Link target="_blank" className={`flex`}
               to="https://drive.google.com/drive/folders/1pQDqIp2EqQIc6O7Jvns6un550VNIIkM7">Brand Kit</Link>
         <Link target="_blank" className={`flex`} to="https://x.com/Vishwa_xyz">Twitter/X</Link>
        </div>

        <div className={`${styles.menu_item} flex`}>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/privacy-policy">Privacy Policy </Link>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/terms-of-service">Terms of Service </Link>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/cookie-policy">Cookie Policy </Link>
        </div>
       </div>
      </div>
    ) : (
      <div className={`${styles.box} w-1340 flex flex-just flex-wrap`}>
       <div className={`${styles.main} ${styles.search}`}>
        <img className={`${styles.logo} pc`} src={logo} alt="VISHWA" />
        <div className={`${styles.main_title}`}>The system behind autonomous capital.</div>
        <div className={`flex`}>
         <Link className={`${styles.link}`} target="_blank"
               to="https://www.youtube.com/@vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M12.5 19.9993L18.9875 15.9993L12.5 11.9993V19.9993ZM26.95 9.55935C27.1125 10.186 27.225 11.026 27.3 12.0927C27.3875 13.1593 27.425 14.0793 27.425 14.8793L27.5 15.9993C27.5 18.9193 27.3 21.066 26.95 22.4393C26.6375 23.6393 25.9125 24.4127 24.7875 24.746C24.2 24.9193 23.125 25.0394 21.475 25.1194C19.85 25.2127 18.3625 25.2527 16.9875 25.2527L15 25.3327C9.7625 25.3327 6.5 25.1193 5.2125 24.746C4.0875 24.4127 3.3625 23.6393 3.05 22.4393C2.8875 21.8127 2.775 20.9727 2.7 19.906C2.6125 18.8393 2.575 17.9193 2.575 17.1193L2.5 15.9993C2.5 13.0793 2.7 10.9327 3.05 9.55935C3.3625 8.35935 4.0875 7.58602 5.2125 7.25268C5.8 7.07935 6.875 6.95935 8.525 6.87935C10.15 6.78602 11.6375 6.74602 13.0125 6.74602L15 6.66602C20.2375 6.66602 23.5 6.87935 24.7875 7.25268C25.9125 7.58602 26.6375 8.35935 26.95 9.55935Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://t.me/vishwa_xyz">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M12.2256 24.8673L12.5756 19.2273L22.1756 10.0006C22.6006 9.58727 22.0881 9.38727 21.5256 9.74727L9.67559 17.7339L4.55059 16.0006C3.45059 15.6673 3.43809 14.8539 4.80059 14.2673L24.7631 6.05394C25.6756 5.61394 26.5506 6.29394 26.2006 7.78727L22.8006 24.8673C22.5631 26.0806 21.8756 26.3739 20.9256 25.8139L15.7506 21.7339L13.2631 24.3073C12.9756 24.6139 12.7381 24.8673 12.2256 24.8673Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://x.com/Vishwa_xyz">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <g clipPath="url(#clip0_5583_240)">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M24.5727 6.28125H21.1512L15.7402 12.6088L11.0033 6.35918H4.19922L12.155 16.8012L4.39357 25.8772H7.89287L13.7908 18.9482L19.1294 25.9551H25.8558L17.3636 14.7507L24.5727 6.28125ZM10.0312 8.18852H7.95887L20.1014 24.1256H22.1106L10.0312 8.18852Z"
                  fill="#D3D1D1" />
           </g>
           <defs>
            <clipPath id="clip0_5583_240">
             <rect width="30" height="32" fill="white" />
            </clipPath>
           </defs>
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://medium.com/vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M25.9726 6.22285L26 6.21674V6H20.4092L15.2179 18.4649L10.0267 6.00013H4.00204V6.21674L4.02902 6.22285C5.04946 6.45819 5.56769 6.80911 5.56769 8.07458V22.8907C5.56769 24.1563 5.04755 24.5072 4.02698 24.7426L4 24.7487V24.9659H8.08761V24.7495L8.0605 24.7432C7.04006 24.508 6.52195 24.157 6.52195 22.8915V8.934L13.1907 24.9659H13.5689L20.4319 8.48699V23.2574C20.3444 24.2569 19.831 24.5656 18.9069 24.7787L18.8796 24.7852V25H26V24.7852L25.9726 24.7787C25.0475 24.5656 24.5218 24.2569 24.4343 23.2574L24.4296 8.07458H24.4343C24.4343 6.80911 24.9525 6.45819 25.9726 6.22285Z"
             fill="#D3D1D1" />
          </svg>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://www.linkedin.com/company/vishwanetwork">
          <div style={{ width: '32px', height: '30px' }} className={`flex items-center justify-center`}>
           <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <g clipPath="url(#clip0_5583_246)">
             <path
               d="M18.7431 18.7477H15.4853V13.6427C15.4853 12.4254 15.4605 10.8588 13.7876 10.8588C12.089 10.8588 11.8296 12.1834 11.8296 13.5529V18.7477H8.57175V8.25H11.7013V9.68092H11.7434C12.1807 8.85592 13.244 7.98508 14.8326 7.98508C18.1335 7.98508 18.744 10.1576 18.744 12.9855V18.7477H18.7431ZM4.89225 6.81358C4.64372 6.8137 4.39761 6.76481 4.168 6.6697C3.93839 6.5746 3.72979 6.43514 3.55413 6.25932C3.37848 6.0835 3.23923 5.87476 3.14434 5.64506C3.04946 5.41536 3.00081 5.1692 3.00117 4.92067C3.00135 4.54646 3.11249 4.18072 3.32054 3.86968C3.52858 3.55865 3.82419 3.31629 4.16998 3.17325C4.51576 3.03022 4.8962 2.99294 5.26318 3.06612C5.63015 3.1393 5.96719 3.31966 6.23166 3.58439C6.49613 3.84911 6.67617 4.18632 6.74899 4.55337C6.82182 4.92042 6.78416 5.30082 6.6408 5.64647C6.49743 5.99212 6.25478 6.28749 5.94354 6.49523C5.63231 6.70298 5.26645 6.81376 4.89225 6.81358ZM6.52575 18.7477H3.25875V8.25H6.52575V18.7477ZM20.3729 0H1.62342C0.726 0 0 0.7095 0 1.58492V20.4151C0 21.2914 0.726 22 1.62342 22H20.3702C21.2667 22 22 21.2914 22 20.4151V1.58492C22 0.7095 21.2667 0 20.3702 0H20.3729Z"
               fill="#D3D1D1" />
            </g>
            <defs>
             <clipPath id="clip0_5583_246">
              <rect width="22" height="22" fill="white" />
             </clipPath>
            </defs>
           </svg>
          </div>
         </Link>

         <Link className={`${styles.link}`} target="_blank" to="https://discord.gg/vishwanetwork">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
           <path
             d="M18.3785 7C18.144 7.41199 17.9334 7.8382 17.742 8.27387C15.9232 8.00394 14.0709 8.00394 12.2473 8.27387C12.0607 7.8382 11.8453 7.41199 11.6107 7C9.90202 7.28887 8.23635 7.79558 6.65689 8.51065C3.52664 13.0994 2.67947 17.5699 3.10067 21.9787C4.93385 23.3189 6.98716 24.3418 9.17451 24.9952C9.66747 24.3418 10.1031 23.6456 10.4764 22.9211C9.76798 22.6606 9.08354 22.3339 8.42783 21.955C8.60014 21.8319 8.76764 21.704 8.9304 21.5809C12.7738 23.3709 17.2251 23.3709 21.0732 21.5809C21.236 21.7135 21.4035 21.8414 21.5758 21.955C20.9201 22.3386 20.2356 22.6606 19.5225 22.9258C19.8958 23.6504 20.3313 24.3465 20.8244 25C23.0117 24.3465 25.065 23.3283 26.8982 21.9881C27.396 16.8737 26.0462 12.4412 23.3324 8.51541C21.7577 7.80032 20.092 7.29361 18.3833 7.00947L18.3785 7ZM11.0124 19.2652C9.83023 19.2652 8.84899 18.2044 8.84899 16.8927C8.84899 15.5809 9.79189 14.5154 11.0076 14.5154C12.2234 14.5154 13.1902 15.5856 13.1711 16.8927C13.1519 18.1997 12.2186 19.2652 11.0124 19.2652ZM18.9864 19.2652C17.7994 19.2652 16.8278 18.2044 16.8278 16.8927C16.8278 15.5809 17.7707 14.5154 18.9864 14.5154C20.2021 14.5154 21.1642 15.5856 21.145 16.8927C21.1259 18.1997 20.1926 19.2652 18.9864 19.2652Z"
             fill="#D3D1D1" />
          </svg>
         </Link>
        </div>
       </div>

       <div className={`${styles.menu} relative flex`}>
        <div className={`${styles.menu_item} flex`}>
         <Link target="_self" className={`flex`} to="/blog">Blogs</Link>
         <Link target="_blank" className={`flex`}
               to="https://drive.google.com/drive/folders/1pQDqIp2EqQIc6O7Jvns6un550VNIIkM7">Brand Kit</Link>
         <Link target="_blank" className={`flex`} to="https://x.com/Vishwa_xyz">Twitter/X</Link>
        </div>

        <div className={`${styles.menu_item} flex`}>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/privacy-policy">Privacy Policy </Link>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/terms-of-service">Terms of Service </Link>
         <Link className={`flex`} onClick={() => window.scrollTo(0, 0)} to="/cookie-policy">Cookie Policy </Link>
        </div>
       </div>
      </div>
    )
   }
  </footer>
 )
}

export default Footer